import { IS_DEV } from "@/data/constants";
import { TUserPlanData } from "@/types/plan-data";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "reactfire";
import { PosthogService } from "../index";

export const usePostHog = () => {
  const auth = useAuth();
  const qc = useQueryClient();
  const userEmail = auth.currentUser?.email;

  const planData = qc.getQueryData<TUserPlanData>(["user-plan-data"]);

  const defaultOptions = {
    platform: "website",
    location: window.location.pathname,
    email: auth.currentUser ? userEmail : "not signed",
    planName: auth.currentUser ? planData?.planName : null,
    planInterval: auth.currentUser ? planData?.recurring?.interval : null,
  };

  const registerPostHog = (eventName: string, options?: any) => {
    if (IS_DEV) return;
    PosthogService.capture(eventName, { ...defaultOptions, ...options });
  };

  return { registerPostHog };
};

export default usePostHog;
